module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2-label"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "pt1"
    }
  }), _vm._v("PART ONE")]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_c('em', [_vm._v("The Land")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', [_vm._v("The flatter the land oh yes the flatter land but of course")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', [_vm._v("the flatter the land and the sea is as flat as the land")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', [_vm._v("oh yes the flatter the land the more yes the more")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', [_vm._v("it has may have to do with the human mind")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_vm._v("GERTRUDE STEIN")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b83722","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292767317_09_pt1.vue
// module id = 84
// module chunks = 0